import React from "react";
import Select from "react-select";

export const StyledSelect = (props) => {
  const newProps = { ...props };
  const { onChange, onBlur, name, formik, defiaultValue } = newProps;

  const onChangeOverride = (selected, options) => {
    if (onChange) {
      onChange(selected, options);
    }
    if (name && formik) {
      formik.setFieldValue(name, selected && selected.value);
    }
  };

  const onBlurOverride = (event) => {
    if (onBlur) {
      onBlur(event);
    }
    if (name && formik) {
      formik.setFieldTouched(name);
    }
  };

  newProps.onChange = onChangeOverride;
  newProps.onBlur = onBlurOverride;

  return (
    <Select
      {...newProps}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary50: "primary",
        },
      })}
      defaultValue={defiaultValue}
      styles={{
        option: (provided, state) => {
          if (state.isSelected || state.isFocused) {
            return {
              ...provided,
              backgroundColor: "var(--primary)",
              color: "var(--white)",
              ":focus": {
                backgroundColor: "var(--danger)",
                color: "var(--white)",
              },
              ":hover": {
                backgroundColor: "var(--danger)",
                color: "var(--white)",
              },
            };
          }
          return provided;
        },
        control: (provided, state) => {
          const result = {
            ...provided,
            fontSize: "1rem",
          };
          if (state.isSelected || state.isFocused) {
            return {
              ...result,
              ":hover": {
                borderColor: "var(--primary)",
                boxShadow: "0 0 0 0.2rem rgb(191 13 62 / 25%)",
              },
              borderColor: "var(--primary)",
              boxShadow: "0 0 0 0.2rem rgb(191 13 62 / 25%)",
            };
          }
          return result;
        },
      }}
    />
  );
};

StyledSelect.propTypes = Select.propTypes;
